import { render, staticRenderFns } from "./compyindex.vue?vue&type=template&id=60085dd2&scoped=true&"
import script from "./compyindex.vue?vue&type=script&lang=js&"
export * from "./compyindex.vue?vue&type=script&lang=js&"
import style0 from "./compyindex.vue?vue&type=style&index=0&id=60085dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60085dd2",
  null
  
)

export default component.exports